import React from "react";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles } from "@material-ui/core/styles";

const useCardStyles = makeStyles((theme) => ({
    root: {
        display: "grid",
        gridTemplateColumns: "[first] 50% [seccond] 50%",

        [theme.breakpoints.down(350)]: {
            gridGap: "2px",
        },
    },
}));

const useFormHelperStyles = makeStyles((theme) => ({
    root: {
        fontSize: "12px",
        textAlign: "center",
        fontWeight: "500",
        marginTop: "5px",
    },
}));

const RadioButtonGroup = (props) => {
    const {
        index,
        name,
        error,
        saveToAppState,

        formControlStyles,
        value,
        onChange,
        row,
        card,
        helperText,
        onComplete,
        autoContinue,
        children,
    } = props;

    const cardVariantStyles = useCardStyles();
    const formHelperTextStyles = useFormHelperStyles();

    const handleOnChange = async (e) => {
        const updatedValue = e.target.value;
        saveToAppState(updatedValue);
        onChange(updatedValue);
        if (autoContinue) await onComplete(index);
    };

    return (
        <FormControl
            component="fieldset"
            error={!!error}
            classes={formControlStyles}
        >
            <RadioGroup
                row={row}
                value={value}
                onChange={handleOnChange}
                {...(card) && { classes: cardVariantStyles }}
            >
                {children}
            </RadioGroup>
            <FormHelperText
                classes={formHelperTextStyles}
            >
                {helperText}
            </FormHelperText>
        </FormControl>
    );
};

export default RadioButtonGroup;